import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { PotentialConsequence } from '../models/potential-consequence.model';
import { Observable } from 'rxjs';
import { UpdatePotentialConsequenceRequest } from '../models/requests/update-potential-consequence-request';
import { CreatePotentialConsequenceRequest } from '../models/requests/create-potential-consequence-request';

@Injectable({
  providedIn: 'root',
})
export class PotentialConsequenceService {
  constructor(private apiService: ApiService) {}

  public GetByRuleUid(
    ruleUniqueId: string | undefined
  ): Observable<PotentialConsequence[]> {
    const options = {
      queryParams: {
        ruleUniqueId: ruleUniqueId ? ruleUniqueId.toString() : '',
      },
    };
    return this.apiService.get<PotentialConsequence[]>(
      `/PotentialConsequence/GetByRuleUid`,
      options
    );
  }

  public DeleteMultiplePotentialConsequences(uids: string[]): Observable<any> {
    return this.apiService.post(`/PotentialConsequence/DeleteMultiple`, uids);
  }

  public UpdateMultiplePotentialConsequences(
    payload: UpdatePotentialConsequenceRequest[]
  ): Observable<PotentialConsequence[]> {
    return this.apiService.put<PotentialConsequence[]>(
      `/PotentialConsequence/UpdateMultiple`,
      payload
    );
  }

  public CreateMultiplePotentialConsequences(
    payload: CreatePotentialConsequenceRequest[]
  ): Observable<PotentialConsequence[]> {
    return this.apiService.post<PotentialConsequence[]>(
      `/PotentialConsequence/CreateMultiple`,
      payload
    );
  }
}
